import { addDays, getHours, getMinutes, setHours, setMinutes, startOfMinute } from 'date-fns';
import type { EventReminder } from 'models';
import { useMemo } from 'react';
import { getDatePickerDateType } from 'ui';
import { useFormatTime, useGenerateDefaultReminderHeroImage } from '../../../hooks';
import type { DuplicateReminderFormValues } from '../DuplicateReminderForm';

export const useGetInitialValues = (event: EventReminder) => {
  const formatTime = useFormatTime();
  const defaultHeroImage = useGenerateDefaultReminderHeroImage();

  return useMemo((): Partial<DuplicateReminderFormValues> => {
    const { allDay: isAllDay, html, name, startTime, text } = event;
    const tomorrowStartDate = startOfMinute(
      setMinutes(setHours(addDays(new Date(), 1), getHours(startTime)), getMinutes(startTime)),
    );

    return {
      duplicateInviteesFromEvent: true,
      heroImage: defaultHeroImage,
      htmlDescription: html,
      isAllDay: isAllDay ?? false,
      name,
      startDate: getDatePickerDateType(tomorrowStartDate),
      startTime: formatTime(tomorrowStartDate),
      textDescription: text,
    };
  }, [defaultHeroImage, event, formatTime]);
};
